module.exports = __webpack_public_path__ + "img/02-W.d01ca5bd.svg";